import { WORKER_TOPIC_TRANSFORM } from "../constants";
import triggerFileDownload from "./triggerFileDownload";
import { processInWorker } from "../utils";

export default async function transformExportData({
  abortController,
  chunk = [],
  chunkNumber,
  exportStats = {},
  onTruncate,
  transforms = {},
}) {
  const { customRowTransformFn, ...transformsMeta } = transforms;

  if (chunk.length > 0) {
    chunk.forEach((row) => customRowTransformFn?.(row));

    const { exportData, headers, truncatedFields } = await processInWorker({
      messageData: {
        chunk,
        exportStats,
        transforms: transformsMeta,
      },
      messageID: chunkNumber,
      messageTopic: WORKER_TOPIC_TRANSFORM,
    });

    exportStats.data = exportData;
    exportStats.headers = headers;
    exportStats.truncatedFields = truncatedFields;
  } else if (exportStats.totalItems === 0) {
    // scenario for downloading blank template
    exportStats.data = [transforms.flatModel];
    exportStats.headers = transforms.flatModel;
  }

  if (abortController?.signal?.aborted) {
    return;
  }

  await triggerFileDownload({
    abortController,
    exportStats,
    onTruncate,
    transforms: transformsMeta,
  });
}
